import { useCallback } from "react";
import { ShareholderForm } from "../../../commons/ShareholderComponents";

const AddShareholder = ({
  setShowShareholderModel,
  setShareholderArray,
  shareholderArray,
  company_id,
  isEdit,
  total_number_of_shares,
}) => {
  const handleClose = useCallback(() => {
    setShowShareholderModel(false);
  }, [setShowShareholderModel]);

  const handleModalContentClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <div className="model" onClick={handleClose}>
      <div
        className="bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-full max-w-lg min-h-40 py-6 px-6 sm:mx-auto mx-6 relative"
        onClick={handleModalContentClick}
      >
        <h2 className="sm:text-2xl text-base font-ebGaramond border-b border-secondary_grey w-full pb-3 mb-4">
          {isEdit?.id ? "Edit" : "Add"} Shareholder
        </h2>
        <ShareholderForm
          isEdit={isEdit}
          onClose={handleClose}
          onSuccess={handleClose}
          company_id={company_id}
          shareholderArray={shareholderArray}
          setShareholderArray={setShareholderArray}
          showShareInfo
          showDocumentUpload
          total_number_of_shares={total_number_of_shares}
        />
      </div>
    </div>
  );
};

export default AddShareholder;
